var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useModal } from "@animech/ui";
import * as Styled from "./predefined-systems-tab.style";
import { ImageSelectContainer } from "ui/components/elements/input/image-select/image-select-container";
import { TabHeader, TabSubHeader, } from "ui/components/panels/home-menu/tabs/tab-header";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { systemTemplateNoneSelected, systemTemplateSelectedFieldName, } from "api/tacton/constants";
import { PageRoute } from "utility/url";
import { CustomImageSelect } from "ui/components/elements/input/image-select";
import { useConfigIdContext } from "providers/config-id";
import { LoadingModal } from "ui/components/modals/loading-modal/loading-modal";
export var PredefinedSystemsTab = function () {
    var _a = useConfigIdContext(), startConfig = _a.startConfig, ticket = _a.ticket;
    var openModal = useModal();
    var loadingModalRef = useRef(null);
    var _b = __read(useState(false), 2), hasPendingTemplateChoice = _b[0], setHasPendingTemplateChoice = _b[1];
    var _c = __read(useState(false), 2), isCommitting = _c[0], setIsCommitting = _c[1];
    var navigate = useNavigate();
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var isLoadingOnSelectApplicationStep = useAppSelector(selectors.selectIsLoadingSelectApplication);
    var applicationTemplateCode = useAppSelector(selectors.selectApplicationTemplateCode);
    var templateGroups = useAppSelector(selectors.selectSystemTemplateGroups);
    var selectedTemplateParameter = useAppSelector(selectors.selectSelectedApplicationTemplate);
    var showLoadingModal = useCallback(function () {
        if (!loadingModalRef.current) {
            loadingModalRef.current = openModal(_jsx(LoadingModal, { translationKey: "home-menu.predefined-systems.loading" }));
        }
    }, [openModal]);
    var closeLoadingModal = useCallback(function () {
        var _a;
        (_a = loadingModalRef.current) === null || _a === void 0 ? void 0 : _a.close();
        loadingModalRef.current = null;
    }, []);
    var commitSelectedTemplate = useCallback(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isCommitting) {
                        return [2 /*return*/];
                    }
                    setIsCommitting(true);
                    showLoadingModal();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(actions.setSelectApplicationParameters({
                            parameters: [systemTemplateSelectedFieldName],
                            values: [value],
                        }))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error("Could not commit template selection");
                    setHasPendingTemplateChoice(false);
                    return [3 /*break*/, 4];
                case 4:
                    closeLoadingModal();
                    setIsCommitting(false);
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, isCommitting, showLoadingModal, closeLoadingModal]);
    useEffect(function () {
        var loadTemplate = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!applicationTemplateCode ||
                            !hasPendingTemplateChoice ||
                            isCommitting) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, dispatch(actions.loadTemplateSystem({
                                templateData: applicationTemplateCode,
                            }))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, startConfig(ticket)];
                    case 2:
                        _a.sent();
                        navigate(PageRoute.SYSTEM_DESIGN);
                        return [2 /*return*/];
                }
            });
        }); };
        loadTemplate();
    }, [
        applicationTemplateCode,
        dispatch,
        isCommitting,
        navigate,
        startConfig,
        ticket,
        hasPendingTemplateChoice,
    ]);
    return (_jsxs(Styled.PredefinedSystemsTab, { children: [_jsx(TabHeader, { header: t("home-menu.predefined-systems.header") }), _jsx(TabSubHeader, { header: t("home-menu.predefined-systems.sub-header") }), templateGroups.length === 0 && !isLoadingOnSelectApplicationStep ? (_jsx(Styled.EmptyText, { children: t("home-menu.predefined-systems.empty") })) : null, templateGroups.map(function (group) {
                var labels = group.members.map(function (template) { return template.description || template.name; });
                var images = group.members.map(function (template) { return template.image || "img/app/system-placeholder.png"; });
                var values = group.members.map(function (template) { return template.value; });
                return (_jsxs("div", { children: [_jsx(TabSubHeader, { header: group.description || "" }), _jsx(ImageSelectContainer, { children: _jsx(CustomImageSelect, { value: (selectedTemplateParameter === null || selectedTemplateParameter === void 0 ? void 0 : selectedTemplateParameter.value) || systemTemplateNoneSelected, items: values, itemLabels: labels, itemImages: images, onValueChange: commitSelectedTemplate, onConfirmChoice: function () { return setHasPendingTemplateChoice(true); }, withConfirmButton: true }) })] }, group.description));
            })] }));
};
